import { invariant } from "tpm-utils";
import $ from "jquery";
import Widget from "./base.js";
import sortBy from "lodash/sortBy";
import isElement from "lodash/isElement";
import { setCookie, getCookie } from "tpm-utils";

/*
  accepts 'sm', 'md', 'lg', 'xl' as args

  at widths larger than or equal to min, show the ad
  at widths smaller than max, show the ad

  might wanna spin this off it's its own file for importing elsewhere? depends on what template needs
 */
function shouldRenderAd(min = null, max = null) {
	const breaks = {
		xl: 1200,
		lg: 1024,
		md: 768,
		sm: 576,
	};
	let overMin = true;
	let underMax = true;
	if (min) overMin = window.innerWidth > breaks[min];
	if (max) underMax = window.innerWidth <= breaks[max];
	return overMin && underMax;
}

export class AdSlot extends Widget {
	setUpAd() {
		const slotEl = document.createElement("div");

		slotEl.className = `htlad-${this.props.unit}`;

		if (typeof htlbid === "undefined") return;

		if (!this.props.nohtlbid) {
			htlbid.cmd.push(() => {
				this._domNode.appendChild(slotEl);
				this.setState({ slotEl });
			});
		}
	}

	get isWideDesktopWidth() {
		return window.innerWidth >= 1281;
	}

	get isDesktopWidth() {
		return window.innerWidth >= 1020 && window.innerWidth < 1281;
	}

	get isTabletWidth() {
		return window.innerWidth >= 782 && window.innerWidth < 1020;
	}

	get isMobileWidth() {
		return window.innerWidth < 782;
	}

	componentDidMount() {
		if (this.noAds()) return;
		console.log("componentDidMount AdSlot", this.props.unit);

		//make the fp device exclusions work
		if (this.props.excludeDesktop && this.isDesktopWidth) return;
		if (this.props.excludeTablet && this.isTabletWidth) return;
		if (this.props.excludeMobile && this.isMobileWidth) return;
		//make the fp prime member exclusion work
		if (this.props.excludePrime && window.is_prime && !window.is_adfree) return;

		this.setUpAd();
	}

	noAds() {
		//no ads on pages with these paths
		if (
			window.location.pathname.indexOf("/prime") > -1 ||
			window.location.pathname.indexOf("/users") > -1 ||
			window.location.pathname.indexOf("/account") > -1 ||
			window.location.pathname.indexOf("/memberships") > -1 ||
			window.location.pathname.indexOf("/signin") > -1
		) {
			return true;
		}

		//no ads for members on the fp
		if (
			window.is_prime &&
			document.body.classList.contains("newspack-front-page")
		) {
			return true;
		}

		/* If the width settings dont match, dont render this ad */
		const minWidth = this.props.hasOwnProperty("minWidth")
			? this.props.minWidth
			: null;
		const maxWidth = this.props.hasOwnProperty("maxWidth")
			? this.props.maxWidth
			: null;
		return !shouldRenderAd(minWidth, maxWidth);
	}

	getSlotContainer() {
		return $(this._domNode).find(`#${this.state.slotElementId}`)[0];
	}

	shouldComponentUpdate() {
		return false;
	}

	renderContent() {
		if (this.noAds()) return;

		const html = `
			<div class="AdSlot__Remove" style="${window.is_adfree ? "display: none;" : ""}">
				ADVERTISEMENT · 
				<a href="https://talkingpointsmemo.com/memberships">GO AD FREE</a>
			</div>
      <div id="breakout-${this.props.unit}"></div>
    `;
		return (
			<div
				class="da-wrapper"
				ref={(x) => (this._domNode = x)}
				dangerouslySetInnerHTML={{ __html: html }}
			></div>
		);
	}
}
